import { isLandingLite } from '@/lib/landingLite'

type MeshBackdropProps = {
  dimmed?: boolean
}

/**
 * Linear / Raycast-style aurora atmosphere: a soft horizon glow at the top
 * plus two blurred color bands drifting on different cycles. All motion is
 * transform-only on pre-painted layers, so it stays compositor work.
 */
export function MeshBackdrop({ dimmed = false }: MeshBackdropProps) {
  const lite = isLandingLite()

  return (
    <div aria-hidden className="pointer-events-none absolute inset-0 overflow-hidden">
      <div className="absolute inset-0 bg-[#07080c]" />

      <div className="hero-mesh-grid absolute inset-0" />

      {lite ? (
        <div
          className="absolute inset-0"
          style={{
            background:
              'radial-gradient(ellipse 90% 55% at 50% -12%, rgba(113,205,217,0.22), transparent 60%), radial-gradient(ellipse 55% 45% at 80% 12%, rgba(58,83,164,0.2), transparent 55%)',
          }}
        />
      ) : (
        <>
          {/* Static horizon glow — light spilling in from above the fold */}
          <div className="hero-aurora-horizon absolute inset-0" />
          {/* Drifting aurora bands */}
          <div className="hero-aurora hero-aurora-a" />
          <div className="hero-aurora hero-aurora-b" />
        </>
      )}

      <div
        className="hero-grain absolute inset-0 mix-blend-overlay"
        style={{
          backgroundImage:
            "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\")",
          backgroundSize: '180px 180px',
        }}
      />

      {dimmed && <div className="absolute inset-0 bg-black/50" />}
    </div>
  )
}
